import { UserAPI } from 'api/user';
import { LS_TEMPLATE_ID_KEY } from 'constant/constant';
import { ApiKey, logger, TokenType } from 'services';
import { authService } from 'services/auth-service';
import { logout } from 'utils/logout';
const SCOPES = [
    'offline_access',
    'openid',
    'profile',
    'email'
];
const authState = (_authState, error)=>({
        isAuthenticated: ApiKey.exists() || authService.getAuthState(),
        error
    });
const logAndReturnAuthState = (state, error)=>{
    const result = authState(state, error);
    logger.debug('transformed auth state', {
        result
    });
    return result;
};
export const OKTA_REDIRECT_URI = window.location.origin;
export const CONFIG = (issuer, clientId, redirect_uri = OKTA_REDIRECT_URI)=>({
        issuer,
        clientId,
        redirectUri: `${redirect_uri}/implicit/callback`,
        scopes: SCOPES,
        pkce: true,
        tokenManager: {
            autoRenew: false,
            autoRemove: false
        },
        postLogoutRedirectUri: `${redirect_uri}/login`,
        transformAuthState: async (_, state)=>{
            const params = new URLSearchParams(window.location.search);
            if (params.get('templateId')) {
                localStorage.setItem(LS_TEMPLATE_ID_KEY, params.get('templateId'));
            }
            logAndReturnAuthState(state, state === null || state === void 0 ? void 0 : state.error);
            const authenticated = ApiKey.exists();
            if (!authenticated && state.accessToken != null) {
                try {
                    await ApiKey.create(state.accessToken.accessToken, TokenType.Okta, clientId);
                } catch (error) {
                    logger.error('api key creation failed', {
                        error
                    });
                    return logAndReturnAuthState(state, error);
                }
                try {
                    await UserAPI.clearOktaSession();
                } catch (error) {
                    logger.error('could not clear okta session via API, logging out', {
                        error
                    });
                    logout();
                }
            }
            return logAndReturnAuthState(state);
        }
    });
